import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people-fill" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pen" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-emoji-angry" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cup-hot" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-circle" })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bar-chart-steps" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-tag" })
], -1)
const _hoisted_9 = { key: 0 }

import { minuteCalc } from '@/logic/_infra/time';
import { TicketRmodel } from '@/app.context/workspace/ticket.rmodel';
import { TodoRmodel } from '@/app.context/workspace/tickets/todo.rmodel';
//C:\Work\mailnum\web.mn\src\logic\workspaces\persons\_def.ts
import {Category} from '@/logic/workspaces/persons/_def'
import { GroupRmodel } from '@/app.context/workspace/persons.set/group.rmodel';
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import { OccupationtRef } from '@/logic/workspaces/tickets/_def';



export default /*#__PURE__*/_defineComponent({
  __name: 'EffortTextComponent',
  props: {
    item: {},
    minutes: {}
  },
  setup(__props: any) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.item.ticket != null)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(" #"),
          _createElementVNode("strong", null, _toDisplayString(_ctx.item.ticket.n), 1),
          _createTextVNode(),
          _createElementVNode("span", null, _toDisplayString(_ctx.item.ticket.name), 1)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.item.category == _unref(Category).M)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_1,
                _createElementVNode("span", null, _toDisplayString(_ctx.item.title), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.groups.values(), (g) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: g.uid.toString()
                  }, "@@ " + _toDisplayString(g.name), 1))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.persons.values(), (p) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: p.nid.toString()
                  }, "@" + _toDisplayString(p.name), 1))
                }), 128))
              ], 64))
            : (_ctx.item.category == _unref(Category).N)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_2,
                  _createElementVNode("span", null, _toDisplayString(_ctx.item.title), 1)
                ], 64))
              : (_ctx.item.category == _unref(Category).L)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _hoisted_3,
                    _createElementVNode("span", null, _toDisplayString(_ctx.item.title), 1)
                  ], 64))
                : (_ctx.item.category == _unref(Category).I)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _hoisted_4,
                      _createElementVNode("span", null, _toDisplayString(_ctx.item.title), 1)
                    ], 64))
                  : (_ctx.item.category == _unref(Category).X)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _hoisted_5,
                        _createElementVNode("span", null, _toDisplayString(_ctx.item.title), 1)
                      ], 64))
                    : (_ctx.item.category == _unref(Category).P)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                          _hoisted_6,
                          _hoisted_7,
                          _createElementVNode("span", null, _toDisplayString(_ctx.item.title), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                          _hoisted_8,
                          _createElementVNode("span", null, _toDisplayString(_ctx.item.category), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.item.title), 1)
                        ], 64))
        ], 64)),
    _createElementVNode("i", null, [
      (_ctx.minutes ?? 1 > 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(" + _toDisplayString(_unref(minuteCalc).toAproximatedHoursString(_ctx.minutes!)) + ")", 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})